/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { ReportScheduleDto } from '../../models/report-schedule-dto';

export interface ReportSchedulesScheduleIdGet$Json$Params {
  scheduleId: string;
}

export function reportSchedulesScheduleIdGet$Json(http: HttpClient, rootUrl: string, params: ReportSchedulesScheduleIdGet$Json$Params, context?: HttpContext): Observable<StrictHttpResponse<ReportScheduleDto>> {
  const rb = new RequestBuilder(rootUrl, reportSchedulesScheduleIdGet$Json.PATH, 'get');
  if (params) {
    rb.path('scheduleId', params.scheduleId, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'text/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<ReportScheduleDto>;
    })
  );
}

reportSchedulesScheduleIdGet$Json.PATH = '/report-schedules/{scheduleId}';
